import React from 'react';
import propTypes from 'prop-types';
import NextImage from 'next/image';
import { AspectRatio } from '@chakra-ui/react';
import { Box } from '@chakra-ui/layout';
import { getBlurUrl } from '@outdoorly/util';
import { getImageLoader } from '@outdoorly/util';

const WrappedComponent = (props) => {
  const { image, setImageIndex, index } = props;
  const size = window.innerWidth > 750 ? 725 : window.innerWidth;
  return (
    <Box
      cursor={['auto', 'auto', 'auto', 'zoom-in']}
      onClick={() => setImageIndex(index)}
      backgroundColor="scheme.bgSecondary"
      maxH="724px"
      maxW="724px"
      margin="auto"
    >
      <AspectRatio
        ratio={1}
        width="full"
        overflow="hidden"
        sx={{
          '&  > div > img': {
            WebkitUserDrag: 'none',
            KhtmlUserDrag: 'none',
            MozUserDrag: 'none',
            OUserDrag: 'none',
            MozUserSelect: 'none',
            KhtmlUserSelect: 'none',
            WebkitUserSelect: 'none',
            OUserSelect: 'none',
            userSelect: 'none',
            height: '100%',
          },
          mixBlendMode: 'darken',
        }}
      >
        <NextImage
          src={image?.url}
          layout="fill"
          placeholder="blur"
          objectFit="contain"
          blurDataURL={getBlurUrl(image?.url)}
          quality={100}
          sizes={`${size}px`}
          className="smooth-filter"
          alt={image?.alt}
          itemID={index}
          draggable="false"
          loader={getImageLoader(image?.url)}
        />
      </AspectRatio>
    </Box>
  );
};

export const ProductImagesForCarousel = React.memo(WrappedComponent);

WrappedComponent.propTypes = {
  image: propTypes.shape({
    url: propTypes.string,
    id: propTypes.string,
    alt: propTypes.string,
  }),
  deviceType: propTypes.string,
  imageList: propTypes.arrayOf([propTypes.object]),
  isMoving: propTypes.bool,
  index: propTypes.number,
  setImageIndex: propTypes.func,
};
